var $bc001c7c2396164d$exports = {};
$bc001c7c2396164d$exports = {
    "maximum": `Najve\u{10D}ji`,
    "minimum": `Najmanj`
};


export {$bc001c7c2396164d$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
